import { render, staticRenderFns } from "./JitsiSecureSetting.vue?vue&type=template&id=e0e15666&"
import script from "./JitsiSecureSetting.vue?vue&type=script&lang=js&"
export * from "./JitsiSecureSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports